export const SHOW_CURRICULUM_SECTION = false;
